import { decrementRequests, incrementRequests } from 'api/fetcher';
import axios from 'axios';
import { NotificationName } from 'utils/constants/notification';
import { formatDate } from 'utils/date';

import urlParser from 'bloko/common/urlParser';

import { setLoadCampaignsReport } from 'store/models/campaignsReport';
import { addNotification } from 'store/models/notification';

export default () => {
    return (dispatch, getState) => {
        const { from, to } = getState().campaignsReport;

        dispatch(setLoadCampaignsReport(true));

        const params = {
            dateFrom: formatDate(from),
            dateTo: formatDate(to),
        };

        const queryStr = urlParser.stringify(params);
        const instance = axios.create();
        incrementRequests();

        return instance
            .get(`/api/v1/backoffice/statistics/campaigns?${queryStr}`, {
                timeout: 400000,
                responseType: 'blob',
            })
            .then((res) => {
                const blob = new Blob([res.data], { type: res.data.type });

                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.setAttribute('href', url);

                const contentDisposition = res.headers['content-disposition'];
                let fileName = 'unknown';
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename\s?=\s?(.+)/);
                    if (fileNameMatch && fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                    }
                }

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();

                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            })
            .catch(() => {
                dispatch(addNotification(NotificationName.CampaignsReportError));
            })
            .finally(() => {
                decrementRequests();
                dispatch(setLoadCampaignsReport(false));
            });
    };
};
